import { CreateService, CRUDServiceInterface } from '@/services/service';
import { ProductCategoryEntity } from '@/entities/product-category.entity';

export default class ProductCategoryService
  extends CreateService<ProductCategoryEntity>('product-category')
  implements CRUDServiceInterface<ProductCategoryEntity> {}
